/**
 * Task Status Visibility Constants
 *
 * Default-visible task statuses for filters and lists. Derived from the
 * TaskStatus enum so it stays in sync automatically when statuses change.
 *
 * @module constants/taskStatuses
 */

import { TaskStatus } from '@/types';

/**
 * Task statuses shown by default (all statuses except the archived bucket).
 * Derived from the enum — never hardcode the list.
 */
export const TASK_STATUSES_DEFAULT_VISIBLE: TaskStatus[] = Object.values(
  TaskStatus
).filter((status) => status !== TaskStatus.Archived);

/**
 * Effective status filter: explicit selection, or the default-visible set
 * (hides archived) when none chosen.
 */
export function effectiveTaskStatuses(status: TaskStatus[]): TaskStatus[] {
  return status.length > 0 ? status : TASK_STATUSES_DEFAULT_VISIBLE;
}
